import {
  Text,
  Box,
  Grid,
  List,
  ListItem,
  ListIcon,
  VStack,
  Flex,
  GridItem,
  useTheme,
} from '@chakra-ui/react';
import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { Currency, RoleAccount } from 'src/api/v1-api';
import { formatPrice } from 'src/utils/common';

type RolePriceCardProps = {
  role?: RoleAccount | null;
};

const DEFAULT_CURRENCY = Currency.USD;

const RolePriceCard = ({ role }: RolePriceCardProps) => {
  const theme = useTheme();
  const monthlySubscription = Boolean(role?.marketplace_role.functional?.monthly_subscription);
  return (
    <Box
      mb={4}
      shadow="base"
      borderWidth="1px"
      alignSelf={{ base: 'center', lg: 'flex-start' }}
      borderColor={'gray.200'}
      borderRadius={theme.border_radius.border_radius_2}
      width={'full'}
    >
      <Box py={4} px={10}>
        <Flex direction="column" alignItems="center"></Flex>
        {/* Price */}
        <Grid templateColumns="repeat(5, 1fr)">
          <GridItem
            display={'flex'}
            colSpan={2}
            fontSize="lg"
            fontWeight="600"
            alignItems="center"
            justifyContent="right"
            mr={{ md: 1 }}
          ></GridItem>
          <Flex justifyContent={'center'} alignItems="center" gap={2}>
            <Text>$</Text>
            <Text fontSize="3xl" fontWeight="700">
              {formatPrice(role?.marketplace_role.functional?.pay_to_list?.pricing_card?.price, {
                alwaysCents: false,
                asDecimal: true,
              })}
            </Text>
            <Text fontSize="xl" fontWeight="semibold">
              {' '}
              {DEFAULT_CURRENCY}
            </Text>
            {monthlySubscription && (
              <Text fontSize="xl" fontWeight="semibold">
                /&nbsp;mo.
              </Text>
            )}
          </Flex>
        </Grid>
        {/* Description */}
        <Text fontWeight="300" fontSize="sm" textAlign="center">
          {role?.marketplace_role.functional?.pay_to_list?.info?.text ?? ''}
        </Text>
      </Box>
      {/* Features */}
      <VStack
        bg={`${theme.colors.mainText}11`}
        py={4}
        borderBottomRadius={theme.border_radius.border_radius_2}
        alignItems={'start'}
        px={5}
      >
        <List spacing={3} textAlign="start">
          {role?.marketplace_role.functional?.pay_to_list?.pricing_card?.features?.map(
            (elem: string, index: number) => (
              <ListItem key={index} fontSize="sm">
                <ListIcon as={FaCheckCircle} color="green.500" /> {elem}
              </ListItem>
            ),
          )}
        </List>
      </VStack>
    </Box>
  );
};

export default RolePriceCard;
